module.exports = __webpack_public_path__ + "img/CATEGORY ICON-14.139f8ef7.png";